// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"52b853a1","605":"a0045a51","809":"62452d41","981":"bca43763"}[chunkId] + ".chunk.js";
};